import { cloneDeep } from 'lodash';
import { AnyAction } from 'redux';
import { MailboxType } from '../models/mailBoxModel';
import actionTypes from '../types/mailBoxTypes';

const defaultInitialState: MailboxType = {
  fetchPayerList: 0,
  hospitalConfiguration: [],
  enableCheckSwitch: false,
  payerConfiguration: [],
  enabledPayer: 0,
  centerId: 0,
  isEmailVerificationModalShow: false,
};

const initialState = cloneDeep(defaultInitialState);

const reducer = (state: any = initialState, action: AnyAction): any => {
  switch (action.type) {
    case actionTypes.FETCH_PAYER_LIST:
      return {
        ...state,
        fetchPayerList: state.fetchPayerList + 1,
      };
    case actionTypes.UPDATE_HOSPITAL_EMAIL_CONFIGURATION:
      return {
        ...state,
        hospitalConfiguration: action.payload,
      };
    case actionTypes.SELECT_ENABLED_PAYER:
      return {
        ...state,
        enabledPayer: action.payload,
      };
    case actionTypes.SELECT_CENTER_ID:
      return {
        ...state,
        centerId: action.payload,
      };
    case actionTypes.ENABLE_SWITCH_CHECK:
      return {
        ...state,
        enableCheckSwitch: action.payload,
      };
    case actionTypes.SHOW_EMAIL_VERIFY_MODAL:
      return {
        ...state,
        isEmailVerificationModalShow: action.payload,
      };
    case actionTypes.SET_PAYER_CONFIGURATION:
      return {
        ...state,
        payerConfiguration: action.payload,
      };
    case actionTypes.SET_PAYER_CONFIGURATION:
      return {
        ...state,
        payerConfiguration: action.payload,
      };
    default: return state;
  }
};

export { reducer as mailBoxReducer };
